import { render, staticRenderFns } from "./Fact.vue?vue&type=template&id=330427a0&scoped=true&"
import script from "./Fact.vue?vue&type=script&lang=js&"
export * from "./Fact.vue?vue&type=script&lang=js&"
import style0 from "./Fact.vue?vue&type=style&index=0&id=330427a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330427a0",
  null
  
)

export default component.exports